import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router/index.js'
import './style.css'
import { initAnalytics } from './analytics.js'
import { Capacitor } from '@capacitor/core'
import { initErrorTracking } from './errorTracking.js'
import { initAppUpdate } from './utils/appUpdate.js'

// Нативные сборки: WebView лежит под статус-баром (iOS всегда, Android — с
// targetSdk 35, где edge-to-edge принудительный), и фиксированные шапки
// должны отступать на инсет. Класс включает переменные --safe-top и
// --nav-inset в style.css; в вебе и PWA они остаются нулевыми.
const nativePlatform = Capacitor.getPlatform()
if (nativePlatform === 'ios') {
  document.documentElement.classList.add('native-ios')
} else if (nativePlatform === 'android') {
  document.documentElement.classList.add('native-android')
}


const app = createApp(App)
app.use(createPinia())
app.use(router)

initErrorTracking(app, router)

app.mount('#app')
void initAnalytics()

// Свежая сборка доезжает до установленного приложения сама — см. appUpdate.js
initAppUpdate()

// ── Splash (разметка в index.html) ──────────────────────────────────────────
// Снимаем по двум условиям сразу: приложение смонтировано И анимация доиграла.
// Без второго условия на быстром соединении splash срезало бы на середине
// «письма» логотипа; без первого — за ним оказался бы пустой экран.
;(function hideSplash() {
  const el = document.getElementById('zoya-splash')
  if (!el) return

  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
  const MIN_MS = reduced ? 400 : 2400   // полная длительность анимации из макета
  const started = window.__zoyaSplashStart || performance.timing?.domLoading || Date.now()
  const elapsed = Date.now() - started

  let done = false
  window.__zoyaSplashReady = () => {
    if (done) return
    done = true
    clearTimeout(window.__zoyaSplashFailsafe)
    el.classList.add('zsplash--leave')
    // 350ms — длительность transition:opacity; после неё узел не нужен,
    // иначе он перехватывает клики поверх приложения.
    setTimeout(() => el.remove(), 400)
  }

  // Ждём кадр после монтирования: к этому моменту первый экран уже отрисован,
  // и уход splash не обнажает недорисованную страницу.
  requestAnimationFrame(() => {
    setTimeout(window.__zoyaSplashReady, Math.max(0, MIN_MS - elapsed))
  })
})()
